import { render, staticRenderFns } from "./sales_by_product_analytic_index.vue?vue&type=template&id=380dd6ee&scoped=true&"
import script from "./sales_by_product_analytic_index.vue?vue&type=script&lang=js&"
export * from "./sales_by_product_analytic_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380dd6ee",
  null
  
)

export default component.exports